 import React from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../../components/Navbar";
import SecondNavbar from "../../components/SecondNavbar";
import Footer from "../../components/Footer";
import "./Animal.css";
import lionImg from "../../assets/lion.jpg";
import leopardImg from "../../assets/leopard.jpg";
import rhinoImg from "../../assets/rhino.jpg";
import elephantImg from "../../assets/elephant.jpg";
import buffaloImg from "../../assets/buffaloImg.jpg";
import bannerImg from "../../assets/animalbanner.jpg";

const animals = [
  { id: 1, name: "Lion", image: lionImg },
  { id: 2, name: "Leopard", image: leopardImg },
  { id: 3, name: "Rhino", image: rhinoImg },
  { id: 4, name: "Elephant", image: elephantImg },
  { id: 5, name: "Buffalo", image: buffaloImg },
];

function Animal() {
  const navigate = useNavigate();

  return (
    <div className="animal-page">
      <Navbar />
      <SecondNavbar />

      <section className="hero">
        <img src={bannerImg} alt="Wildlife Banner" className="hero-img"/>
        <div className="overlay"></div>
        <div className="hero-content">
          <h1>Protecting Earth's Greatest Mammals</h1>
          <p>Explore iconic wildlife species and support conservation efforts around the world.</p>
          <button
            className="hero-btn"
            onClick={()=>navigate("/awareness/animal-detail")}
          >
            View Details
          </button>
        </div>
      </section>

      <section className="big-five">
        <h2>The Big Five</h2>
        <div className="animal-grid">
          {animals.map((animal)=>(
            <div className="animal-card" key={animal.id}>
              <img src={animal.image} alt={animal.name} />
              <div className="card-content">
                <h3>{animal.name}</h3>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="tracking">
        <h2>Migration Tracking</h2>
        <p>Monitor wildlife movement through our conservation tracking system.</p>
        <div className="map-box">
          <div className="dot dot1"></div>
          <div className="dot dot2"></div>
          <div className="dot dot3"></div>
        </div>
      </section>

      <section className="journal">
        <h2>Wildlife Journal</h2>
        <p className="journal-text">Explore stories and conservation efforts to protect endangered wildlife.</p>
        <div className="journal-container">
          <div className="journal-card">
            <img src={lionImg} alt="Snow Leopard" />
            <h3>Snow Leopard Conservation</h3>
            <p>Learn how conservationists protect endangered species.</p>
          </div>
          <div className="journal-card">
            <img src={elephantImg} alt="Elephant Migration" />
            <h3>Elephant Migration</h3>
            <p>Follow the incredible migration journey of elephants.</p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default Animal;